import { render } from "./B2bTableCentres.vue?vue&type=template&id=0d60528f&scoped=true&lang=pug"
import script from "./B2bTableCentres.vue?vue&type=script&lang=js"
export * from "./B2bTableCentres.vue?vue&type=script&lang=js"

import "./B2bTableCentres.vue?vue&type=style&index=0&id=0d60528f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d60528f"]])

export default __exports__